import { Check as CheckIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import React from 'react';

interface AcceptChangesButtonProps {
  onAccept: () => void;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
}

const AcceptChangesButton: React.FC<AcceptChangesButtonProps> = ({
  onAccept,
  disabled = false,
  size = 'small',
}) => {
  return (
    <Button
      size={size}
      startIcon={<CheckIcon />}
      onClick={onAccept}
      variant="contained"
      color="success"
      disabled={disabled}
      sx={{
        position: 'relative',
        display: 'grid',
        gridTemplateColumns: 'auto 1fr',
      }}
    >
      Accept Changes
    </Button>
  );
};

export default AcceptChangesButton;
